import {useState} from "react";
import { ActivityLevel } from "@/types/dto/pdp/pdp-header-about";

const usePdpModals = () => {
  // activity level
  const [activityLevelIsOpen, setActivityLevelIsOpen] = useState<boolean>(false);
  const [defaultActivityLevel, setDefaultActivityLevel] = useState<ActivityLevel["number"]>(0);
  const handleOpenActivityLevel = (defaultLevel: ActivityLevel["number"]) => {
    setActivityLevelIsOpen(true);
    setDefaultActivityLevel(defaultLevel);
  };
  const handleCloseActivityLevel = () => {
    setActivityLevelIsOpen(false);
    setDefaultActivityLevel(0);
  };

  // travel styles
  const [travelStylesIsOpen, setTravelStylesIsOpen] = useState<boolean>(false);
  const handleOpenTravelStyles = () => {
    setTravelStylesIsOpen(true);
  };
  const handleCloseTravelStyles = () => {
    setTravelStylesIsOpen(false);
  };

  // on tour air
  const [onTourAirIsOpen, setOnTourAirIsOpen] = useState<boolean>(false);
  const handleOpenOnTourAir = () => {
    setOnTourAirIsOpen(true);
  };
  const handleCloseOnTourAir = () => {
    setOnTourAirIsOpen(false);
  };

  // request a quote
  const [requestAQuoteIsOpen, setRequestAQuoteIsOpen] = useState<boolean>(false);
  const handleOpenRequestAQuote = () => {
    setRequestAQuoteIsOpen(true);
  };
  const handleCloseRequestAQuote = () => {
    setRequestAQuoteIsOpen(false);
  };

  // print
  const [printIsOpen, setPrintIsOpen] = useState<boolean>(false);
  const [printStatus, setPrintStatus] = useState<"building" | "ready" | "error">("building");
  const handleOpenPrint = () => {
    setPrintStatus("building");
    setPrintIsOpen(true);
  };
  const handleClosePrint = () => {
    setPrintIsOpen(false);
  };

  // share
  const [shareIsOpen, setShareIsOpen] = useState<boolean>(false);
  const handleOpenShare = () => {
    setShareIsOpen(true);
  };
  const handleCloseShare = () => {
    setShareIsOpen(false);
  };

  // best time to travel
  const [bestTimeToTravelIsOpen, setBestTimeToTravelIsOpen] = useState<boolean>(false);
  const handleOpenBestTimeToTravel = () => {
    setBestTimeToTravelIsOpen(true);
  };
  const handleCloseBestTimeToTravel = () => {
    setBestTimeToTravelIsOpen(false);
  };

  // offer terms
  const [offerTermsIsOpen, setOfferTermsIsOpen] = useState<boolean>(false);
  const handleOpenOfferTerms = () => {
    setOfferTermsIsOpen(true);
  };
  const handleCloseOfferTerms = () => {
    setOfferTermsIsOpen(false);
  };

  // extension styles
  const [extensionStylesIsOpen, setExtensionStylesIsOpen] = useState<boolean>(false);
  const [currentExtensionStyle, setCurrentExtensionStyle] = useState<string>("");
  const handleOpenExtensionStyles = (extensionStyle:string) => {
    setExtensionStylesIsOpen(true);
    setCurrentExtensionStyle(extensionStyle);
  };
  const handleCloseExtensionStyles = () => {
    setExtensionStylesIsOpen(false);
  };

  return {
    // activity level
    activityLevelIsOpen,
    defaultActivityLevel,
    handleOpenActivityLevel,
    handleCloseActivityLevel,
    // travel styles
    travelStylesIsOpen,
    handleOpenTravelStyles,
    handleCloseTravelStyles,
    // on tour air
    onTourAirIsOpen,
    handleOpenOnTourAir,
    handleCloseOnTourAir,
    // request a quote
    requestAQuoteIsOpen,
    handleOpenRequestAQuote,
    handleCloseRequestAQuote,
    // print
    printIsOpen,
    printStatus,
    setPrintStatus,
    handleOpenPrint,
    handleClosePrint,
    // share
    shareIsOpen,
    handleOpenShare,
    handleCloseShare,
    // best time to travel,
    bestTimeToTravelIsOpen,
    handleOpenBestTimeToTravel,
    handleCloseBestTimeToTravel,
    // offer terms
    offerTermsIsOpen,
    handleOpenOfferTerms,
    handleCloseOfferTerms,
    // extension styles
    extensionStylesIsOpen,
    handleOpenExtensionStyles,
    handleCloseExtensionStyles,
    currentExtensionStyle
  };
};

export default usePdpModals;